import { post } from '../../../Services/ApiClient';
import { isBlob } from './WizardValues.helper';

const uploadFile = async (file: Blob): Promise<string> => {
	const formData = new FormData();
	const fileName = (file as File).name;

	if (fileName) {
		formData.append('file', file, fileName);
	} else {
		formData.append('file', file);
	}

	const result = await post('/wizard/upload', formData);

	if (typeof result.data !== 'string' || !result.data) {
		throw new Error('WizardFileUploadError');
	}

	return result.data;
};

export const uploadWizardFiles = async (data: any): Promise<any> => {
	if (isBlob(data)) {
		return uploadFile(data);
	}

	if (Array.isArray(data)) {
		return Promise.all(data.map(uploadWizardFiles));
	}

	if (
		data &&
		typeof data === 'object' &&
		!(data instanceof Date) &&
		!data._isAMomentObject
	) {
		const entries = await Promise.all(
			Object.entries(data).map(
				async ([key, value]): Promise<[string, any]> => [
					key,
					await uploadWizardFiles(value),
				],
			),
		);

		return Object.fromEntries(entries);
	}

	return data;
};
